module.exports = __webpack_public_path__ + "img/work-8.a994e6bc.png";